import { CountryCode, IAddGiftAccountInput, IApplePay, IGooglePay } from 'generated/rbi-graphql';

import { IAddPrepaidCardArgs } from './types';

export const prepaidCardMapInput = (params: IAddPrepaidCardArgs): IAddGiftAccountInput => {
  if (params.applePayDetails) {
    // TODO: Remove "delete args...PaymentMethodData" objects once it is apart of BE interface call for addPrepaidCardMutation
    const args = { ...params.applePayDetails };
    delete args.PaymentMethodData;

    const apple: IApplePay = {
      applicationData: args.applicationData,
      billingAddress: args.billingAddress,
      country: CountryCode[args.country],
      data: args.data,
      decryptAlias: args.decryptAlias,
      ephemeralPublicKey: args.ephemeralPublicKey,
      formatted: args.formatted,
      paymentData: args.paymentData,
      primary: args.primary,
      publicKeyHash: args.publicKeyHash,
      signature: args.signature,
      transactionId: args.transactionId,
      type: args.type,
      version: args.version,
    };

    return { ...params, applePayDetails: apple, googlePayDetails: undefined };
  }

  if (params.googlePayDetails) {
    // TODO: Remove "delete args...PaymentMethodData" objects once it is apart of BE interface call for addPrepaidCardMutation
    const args = { ...params.googlePayDetails };
    delete args.PaymentMethodData;

    const google: IGooglePay = {
      billingAddress: args.billingAddress,
      country: CountryCode[args.country],
      data: args.data,
      formatted: args.formatted,
      paymentData: args.paymentData,
      primary: args.primary,
      signature: args.signature,
      type: args.type,
      version: args.version,
    };

    return { ...params, applePayDetails: undefined, googlePayDetails: google };
  }

  return { ...params, applePayDetails: undefined, googlePayDetails: undefined };
};
